import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import AddressSection from "@Shared/components/sections/new-sections/address-section";
import { mapActions, mapGetters } from "vuex";
import { EDIT_PAYMENT_METHOD, LOAD_ACCOUNT_PLAN_DETAILS } from "../../store/account-plan-actions";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { formatDateNumber } from "@Shared/@Utils/helpers/text";
import { pick } from "lodash";
import { validationMixin } from "vuelidate";
import { validExpirationDate, validCanadianPostalCode } from "@Shared/@Utils/validation-rules";
import { required } from "vuelidate/lib/validators";
import { PAYMENT_METHODS } from "../../store/account-plan-getters";
import Amplitude from "@Shared/@Utils/amplitude";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PaymentDetailsModal",
  title: "PaymentDetails",
  components: {
    GenericModal,
    AddressSection,
    MaterialInput,
    SimpleButton
  },
  mixins: [validationMixin],
  validations: {
    address: {
      line1: {
        required
      },
      city: {
        required
      },
      province: {
        required
      },
      "postal-code": {
        required,
        validCanadianPostalCode
      }
    },
    cardExpiration: {
      validExpirationDate
    }
  },
  async data() {
    return {
      modalOpened: false,
      address: null,
      loading: false,
      loadingSucceeded: true,
      paymentId: "",
      cardExpiration: "",
      isEditable: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("AccountPlanStore", [PAYMENT_METHODS])), {}, {
    addressCustomExpressions() {
      return {
        line1: "address.line1",
        line2: "address.line2",
        city: "address.city",
        province: "address.province",
        "postal-code": "address.postal-code"
      };
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("AccountPlanStore", [EDIT_PAYMENT_METHOD, LOAD_ACCOUNT_PLAN_DETAILS])), {}, {
    openModal({
      paymentId,
      address,
      cardExpYear,
      cardExpMonth,
      isEditable
    }) {
      this.paymentId = paymentId;
      this.address = _objectSpread(_objectSpread({}, address), {}, {
        "postal-code": address.postal_code || address["postal-code"] || ""
      });
      this.cardExpiration = `${formatDateNumber(cardExpMonth)}/${cardExpYear}`;
      this.$refs.paymentDetails.show();
      this.modalOpened = true;
      this.isEditable = isEditable;
      Amplitude.logEvent("Account Plan - Payment Methods Details Modal Opened", {
        paymentId
      });
    },
    closeModal() {
      if (this.modalOpened) {
        this.modalOpened = false;
        this.$refs.paymentDetails.hide();
        Amplitude.logEvent("Account Plan - Payment Methods Details Modal Closed");
      }
    },
    handleAddressChange(address) {
      this.address = address;
    },
    async editPaymentMethod() {
      this.loading = true;
      const cardExpiration = this.cardExpiration.split("/");
      const result = await this.EDIT_PAYMENT_METHOD({
        paymentId: this.paymentId,
        cardExpMonth: cardExpiration[0],
        cardExpYear: cardExpiration[1],
        address: pick(this.address, ["city", "line1", "line2", "postal-code", "province"])
      });
      this.loadingSucceeded = result.succeeded;
      this.loading = false;
      if (result.succeeded) {
        this.closeModal();
        await this.LOAD_ACCOUNT_PLAN_DETAILS();
      }
      Amplitude.logEvent("Account Plan - Edit Payment Method Details Attempt Completed", {
        paymentId: this.paymentId,
        result
      });
    }
  })
});